import { Modal } from './reducer';


interface OpenModal {
    type: 'OPEN_MODAL';
    modal: Modal;
}

export function openModal(modal: Modal): OpenModal {
    return {
        type: 'OPEN_MODAL',
        modal
    };
}

interface CloseModal {
    type: 'CLOSE_MODAL';
}

export function closeModal(): CloseModal {
    return {
        type: 'CLOSE_MODAL'
    };
}

export type ModalAction =
    | OpenModal
    | CloseModal;